import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Redirect to select-gender since we no longer have a single premium page
export default function PremiumPage() {
  const navigate = useNavigate();
  
  useEffect(() => {
    navigate('/select-gender');
  }, [navigate]);
  
  return null;
}
